import { get, patch } from "@app/common/api";
import type {
  ApiHighlight,
  TranscriptClipType,
  EditableClipType,
} from "@app/common/types";

// TODO: this whole file is basically a dupe of apiClient/clips.
//  delete this file and migrate to using the new generic endpoint

/** @deprecated */
export type CreateClipBody = {
  type: TranscriptClipType;
  createTime: string;
  text: string;
};

/** @deprecated */
export type UpdateClipBody = {
  id: ApiHighlight["id"];
  type: EditableClipType;
  text?: ApiHighlight["text"];
  newType?: TranscriptClipType;
};

/** @deprecated */
export type DeleteClipBody = {
  id: ApiHighlight["id"];
  type: TranscriptClipType;
};

/** @deprecated */
export interface ApiClipPatchOperation {
  id?: string;
  operation: "create" | "update" | "delete";
  clipType: EditableClipType;
  newClipType?: TranscriptClipType;
  startTime?: string;
  endTime?: string;
  text?: string;
}

export const getClips = async (sessionId: string): Promise<ApiHighlight[]> => {
  return get(`/sessions/${sessionId}/highlight-clips`, { withCreds: true });
};

/** @deprecated */
const patchClip = async (
  sessionId: string,
  operation: ApiClipPatchOperation
) => {
  return patch(`/sessions/${sessionId}/clips`, [operation], {
    withCreds: true,
  });
};

/** @deprecated */
export const createClip = async (
  sessionId: string,
  body: CreateClipBody
): Promise<void> => {
  const operation: ApiClipPatchOperation = {
    operation: "create",
    clipType: body.type,
    startTime: body.createTime,
    endTime: body.createTime,
    text: body.text,
  };

  return patchClip(sessionId, operation);
};

/** @deprecated */
export const deleteClip = async (
  sessionId: string,
  body: DeleteClipBody
): Promise<void> => {
  const operation: ApiClipPatchOperation = {
    operation: "delete",
    id: body.id,
    clipType: body.type,
  };

  return patchClip(sessionId, operation);
};

/** @deprecated */
export const updateClip = async (
  sessionId: string,
  body: UpdateClipBody
): Promise<void> => {
  const operation: ApiClipPatchOperation = {
    operation: "update",
    id: body.id,
    clipType: body.type,
    text: body.text,
    newClipType: body.newType,
  };

  return patchClip(sessionId, operation);
};
